
import React, { useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
import CustomArrow from "../utils/CustomStyleComponent/ArrowComponent";
import CustomCrossButton from "../utils/CustomStyleComponent/CrossButtonComponent";
import CustomTooltip from "../utils/CustomStyleComponent/TooltipComponent";
import TableSkeleton from "../components/TableSkeleton";
import "./Product.css";
import Swal from "sweetalert2";
import { singleApprove, deleteIcecatProduct, refuseAllIcecat } from '../generatedRequest/icecatdata'
import { toast } from "react-toastify";

type TproductFormProp = {
  errors: any;

  values: any;

  isEdit: boolean;
  isloading: boolean;
  ProductData: any[];


  icecatProductData: any[];
  referenceError: string;
};

const IcecatForm = ({
  errors,
  isEdit,

  isloading,

  values,
  icecatProductData,
  ProductData,
  referenceError




}: TproductFormProp) => {
  const style = {
    multiselectContainer: {
      minheight: "44px",
      border: "1px solid var(--bs-gray-100)",
    },
    searchBox: {
      minheight: "44px",
      fontSize: "1.1rem",
      fontWeight: "500",
    },
  };

  const navigate = useNavigate();
  let defaultImages = [];

  if (values?.images) {
    defaultImages = values?.images.map((t: any) => {
      return {
        id: t.id,
        url: t.src,
        type: "uploaded",
        file: null,
      };
    });
  }

  const [selectedFilesURL, setSelectedFilesURL] = useState(defaultImages);
  const [selectedValues, setSelectedValues] = useState<Record<string, any>>({});
  const [approveLoading, setApproveLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    const fn = () => {
      const updatedSelectedValues = { ...selectedValues };
      const supportedAttributes = values?.subcategory?.[0]?.supportedAttributes;
      const attributes = values?.attributes;
      if (
        supportedAttributes &&
        supportedAttributes.length > 0 &&
        attributes &&
        attributes.length > 0
      ) {
        for (const supportedAttribute of supportedAttributes) {
          const supportedAttributeName = supportedAttribute.attributeName;

          for (const attribute of attributes) {
            const attributeName = attribute.attributeName;
            if (supportedAttributeName === attributeName) {
              updatedSelectedValues[supportedAttribute._id] =
                supportedAttribute.supportedUnits.filter(
                  (data: any) => data?.name === attribute?.unit?.name
                )[0];
              break;
            }
          }
        }
      }

      setSelectedValues(updatedSelectedValues);
    };

    fn();
  }, [values.attributes, values.subcategory]);


  const handleApprove = async () => {
   
    const result = await Swal.fire({
      title: "",
      text: "Are you sure you want to be able to approve the selected records?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve them!"
    });

    // If user confirmed, proceed with approval
    if (result.isConfirmed) {
      if (!singleApprove) {
        console.error("singleApprove function not provided");
        return;
      }

      // Get product ID - you can modify this based on where the ID is stored
      let productId = icecatProductData?.[0]?._id || icecatProductData?.[0]?.id || ProductData?.[0]?._id || ProductData?.[0]?.id;

      if (!productId) {
        console.error("Product ID not found");
        return;
      }

      try {
        setApproveLoading(true);
        await singleApprove(productId);
        
        // Show success message
        await Swal.fire({
          title: "Approved!",
          text: "Product has been approved successfully.",
          icon: "success"
        });
        
        console.log("Product approved successfully");
        toast.success("Product approved successfully");
        // Optionally navigate back or refresh data
        // navigate("/icecat");
      } catch (error) {
        console.error("Error approving product:", error);
        // Show error message
        await Swal.fire({
          title: "Error!",
          text: "An error occurred while approving the product.",
          icon: "error"
        });
      } finally {
        setApproveLoading(false);
      }
    }
  };
  // console.log(ProductData, "ProductData")


  const handleDelete = async () => {
    // Show SweetAlert2 confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, refuse them!"
    });

    // If user confirmed, proceed with deletion
    if (result.isConfirmed) {
      if (!refuseAllIcecat) {
        console.error("refuseAllIcecat function not provided");
        return;
      }

      let productId = icecatProductData[0]?._id || icecatProductData?.[0]?.id || ProductData?.[0]?._id || ProductData?.[0]?.id;
     
      if (!productId) {
        console.error("Product ID not found");
        return;
      }

      try {
        setDeleteLoading(true);
        await refuseAllIcecat({ ids: [productId] });
      
        // Show success message
        await Swal.fire({
          title: "Refused!",
          text: "Product has been refused successfully.",
          icon: "success"
        });
        
        toast.success("Product refused successfully!");
        navigate("/icecat");
      } catch (error) {
        console.error("Error deleting product:", error);
        // Show error message
        await Swal.fire({
          title: "Error!",
          text: "An error occurred while refusing the product.",
          icon: "error"
        });
      } finally {
        setDeleteLoading(false);
      }
    }
  };


  // console.log(icecatProductData, "icecatProductData")
  return (
    <div className="container ms-1">
      <div className="row">
        <div className="col-md-8">
          <div className="card mb-5 mb-xl-10">
            <div className="card-header border-1 cursor-pointer">
              <div className="card-title m-0">
                <div
                  role={"button"}
                  className="btn btn-sm btn-light me-5"
                  onClick={() => navigate("/icecat")}
                >
                  <i className="fa-solid fa-arrow-left fs-2"></i>
                </div>
                <h3 className="fw-bolder m-0">View Product</h3>
              </div>
            </div>
            <div className="card-body p-9">
              <div className="row mb-6">
                <div className="input-group mb-3">
                  <label className="col-lg-2 col-form-label fw-bold fs-6">
                    Name
                  </label>
                  <div className="col-lg-8">
                    <input
                      disabled={false}
                      placeholder="Product Name"
                      value={icecatProductData?.[0]?.productName || ""}
                      type="text"
                      className="form-control bg-light"
                    />

                    <Multiselect
                      options={icecatProductData}
                      style={style}
                      disable={true}
                      customArrow={<CustomArrow />}
                      groupBy="sourceType"
                      customCloseIcon={<CustomCrossButton />}
                      selectionLimit={1}
                      displayValue={`title`}
                      placeholder="Product Details"
                      selectedValueDecorator={(value, option) => {
                        return <CustomTooltip value={value} option={option} />;
                      }}
                      optionValueDecorator={(value, option) => {
                        return (
                          <div className="d-flex justify-content-between">
                            <span>{value}</span>
                            <span className="text-danger">
                              {`${option?.source}`.toLocaleUpperCase()}
                            </span>
                          </div>
                        );
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="row mb-6">
                <label className="col-lg-2 col-form-label fw-bold fs-6">
                  Brand
                </label>
                <div className="col-lg-4">
                  <input
                    placeholder="Brand"
                    disabled={false}
                    value={icecatProductData?.[0]?.brand || ""}
                    type="text"
                    className="form-control bg-light"
                  />
                </div>

                <label className="col-lg-2 col-form-label fw-bold fs-6">
                  Model
                </label>
                <div className="col-lg-4">
                  <input
                    placeholder="Model"
                    disabled={false}
                    value={
                      icecatProductData?.[0]?.model &&
                        icecatProductData[0].model !== "undefined" &&
                        icecatProductData[0].model !== "undefined undefined"
                        ? icecatProductData[0].model
                        : ""
                    }
                    type="text"
                    className="form-control bg-light"
                  />
                </div>
              </div>

              <div className="row mb-6">
                <label className="col-lg-2 col-form-label fw-bold fs-6">
                  Model Number
                </label>
                <div className="col-lg-4">
                  <input
                    placeholder="Model Number"
                    disabled={false}
                    value={icecatProductData?.[0]?.modelNumber || ""}
                    type="text"
                    className="form-control bg-light"
                  />
                </div>
              </div>

              <div className="row mb-6">
                <label className="col-lg-2 col-form-label fw-bold fs-7">
                  Description
                </label>
                <div className="col-lg-10">
                  <textarea
                    rows={4}
                    disabled={false}
                    autoComplete="off"
                    placeholder="Description"
                    value={icecatProductData?.[0]?.description || ""}
                    className="form-control bg-light"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-10 mb-5">
            <div className="container p-0 m-0">
              <div className="row mb-5">
                <div className="col-md-12">
                  <label className="form-label fs-6 fw-bolder text-dark">
                    Category
                  </label>
                  <div>
                    <input
                      placeholder="Category"
                      disabled={false}
                      value={icecatProductData?.[0]?.category?.categoryName || ""}
                      type="text"
                      className="form-control bg-light"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <label className="form-label fs-6 fw-bolder text-dark">
                  Sub Category
                </label>
                <div>
                  <input
                    placeholder="Sub Category"
                    disabled={false}
                    value={icecatProductData?.[0]?.subcategory?.subcategoryName || ""}
                    type="text"
                    className="form-control bg-light"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card p-10 mb-5">
            <div className="container p-0 m-0">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label fs-6 fw-bolder text-dark">
                    Region
                  </label>
                  <div>
                    <input
                      placeholder="Region"
                      disabled={false}
                      value={icecatProductData?.[0]?.regions?.[0]?.regionName || ""}
                      type="text"
                      className="form-control bg-light"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Improved Specifications Section */}
      <div className="card w-100 mb-5 mb-xl-10">
        <div className="card-header">
          <h3 className="card-title fw-bold">Product Specifications Comparison</h3>
        </div>
        <div className="card-body p-0">
          <div className="row g-0">
            {/* IceCat Specifications Table */}
            <div className="col-lg-6">
              <div className="border-end h-100 p-6">
                <div className="d-flex align-items-center mb-6">
                  <div className="symbol symbol-40px me-4">
                    <div className="symbol-label bg-light-primary">
                      <i className="fa-solid fa-database text-primary fs-4"></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="fw-bold mb-1">
                      {icecatProductData?.[0]?.addProductFrom || "ICECAT"} Data
                    </h4>
                    <span className="text-muted fs-7"> specifications</span>
                  </div>
                </div>

                <div className="table-responsive" style={{ maxHeight: '800px', overflowY: 'auto' }}>
                  {icecatProductData?.[0]?.attributes && icecatProductData[0].attributes.length > 0 ? (
                    (() => {
                      const attributeGroups = {
                        'Power': [
                          'AC adapter power',
                          'Charging port type',
                          'USB-C PD',
                          'USB-C Voltage',
                          'AC input voltage',
                          'Legacy AC adapter tip size',
                          'Legacy Power Tip'
                        ],
                        'Display': [
                          'Display diagonal',
                          'Display resolution',
                          'ASPECT RATIO',
                          'Touchscreen'
                        ],
                        'Video Ports': [
                          'DisplayPorts quantity',
                          'HDMI ports quantity',
                          'DVI port'
                        ],
                        'Cable Locks': [
                          'Cable lock slot',
                          'Cable lock slot type (1)',
                          'Cable lock slot type (2)',
                          'Universal'
                        ],
                        'Type-A ports': [
                          'Number of USB-A Ports',
                          'USB 3.2 GEN 2 (3.1 GEN 2) TYPE-A PORTS QUANTITY',
                          'USB 3.2 Gen 1 (3.1 Gen 1) Type-A ports quantity',
                          'USB 2.0 Type-A Ports Quantity',
                          'USB 2.0 ports quantity'
                        ],
                        'Type-C Ports': [
                          'Number of USB-C Ports',
                          'USB 2.0 Type-C Ports',
                          'USB 3.2 GEN 1 (3.1 GEN 1) TYPE-C PORTS QUANTITY',
                          'USB 3.2 Gen 2 (3.1 Gen 2) Type-C ports quantity',
                          'DisplayPort Alt Mode Type-C Ports',
                          'Thunderbolt 3 Type-C Ports',
                          'Thunderbolt 4 Type-C Ports',
                          'USB4 Type-C ports',
                          'Thunderbolt 5 Type C Ports'
                        ],
                        'Audio Ports': [
                          'Combo headphone/mic port'
                        ],
                        'Communication': [
                          'Ethernet LAN (RJ-45) ports',
                          'Wi-Fi',
                          'Wi-Fi standards',
                          'Bluetooth'
                        ],
                        'Dimensions': [
                          'Width',
                          'Depth',
                          'Height',
                          'Weight'
                        ]
                      };

                      const allDefinedAttributes = Object.values(attributeGroups).flat();
                      const icecatAttributes = icecatProductData[0]?.attributes || [];

                      let groupedAttributes = Object.entries(attributeGroups).map(([groupName, attributeNames]) => ({
                        groupName,
                        attributes: icecatAttributes.filter((attribute: any) =>
                          attributeNames.includes(attribute.attributeName)
                        )
                      }));

                      const otherAttributes = icecatAttributes.filter(
                        (attribute: any) => !allDefinedAttributes.includes(attribute.attributeName)
                      );

                      if (otherAttributes.length > 0) {
                        groupedAttributes.push({
                          groupName: 'Others',
                          attributes: otherAttributes
                        });
                      }

                      groupedAttributes = groupedAttributes.filter(group => group.attributes.length > 0);

                      return groupedAttributes.map(({ groupName, attributes }) => (
                        <div key={`icecat-${groupName}`} className="mb-8">
                          <div className="card card-flush border-0 bg-light">
                            <div className="card-header min-h-50px">
                              <h5 className="card-title fw-bold text-dark-800 m-0">
                                {/* <i className="fa-solid fa-folder-open me-2 text-primary"></i> */}
                                {groupName}
                              </h5>
                            </div>
                            <div className="card-body pt-4">
                              {attributes.map((attribute: any) => (
                                <div key={`icecat-attr-${attribute.attributeName}`} className="row mb-4 align-items-center">
                                  <div className="col-5">
                                    <label className="fw-semibold fs-7 text-dark-700 mb-0">
                                      {attribute.attributeName}
                                    </label>
                                  </div>
                                  <div className="col-7">
                                    <div className="input-group input-group-sm">
                                      <input
                                        value={attribute.value || "N/A"}
                                        disabled={true}
                                        className="form-control form-control-sm bg-white border-dark-300 text-dark"
                                        type="text"
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ));
                    })()
                  ) : (
                    <div className="text-center py-10">
                      <div className="symbol symbol-100px mx-auto mb-4">
                        <div className="symbol-label bg-light-warning">
                          <i className="fa-solid fa-exclamation-triangle text-warning fs-1"></i>
                        </div>
                      </div>
                      <h5 className="text-muted fw-semibold">No IceCat Specifications Available</h5>
                      <p className="text-muted fs-7">No specifications data found for this product.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Product Specifications Table */}
            <div className="col-lg-6">
              <div className="h-100 p-6">
                <div className="d-flex align-items-center mb-6">
                  <div className="symbol symbol-40px me-4">
                    <div className="symbol-label bg-light-success">
                      <i className="fa-solid fa-box text-success fs-4"></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="fw-bold mb-1">Product Data</h4>
                    <span className="text-muted fs-7"> specifications</span>
                  </div>
                </div>

                <div className="table-responsive" style={{ maxHeight: '800px', overflowY: 'auto' }}>
                  {(ProductData.length === 0 && !referenceError) ? (
                    <div className="text-center py-10">
                      <TableSkeleton rows={5} columns={2} />
                    </div>
                  ) : (!ProductData || ProductData.length === 0 && referenceError) ? (
                    <div className="text-center py-10">
                      <div className="symbol symbol-100px mx-auto mb-4">
                        <div className="symbol-label bg-light-warning">
                          <i className="fa-solid fa-exclamation-triangle text-warning fs-1"></i>
                        </div>
                      </div>
                      <h5 className="text-muted fw-semibold">No Product Available</h5>

                    </div>
                  ) : (ProductData.length > 0 && (!ProductData[0]?.attributes || ProductData[0]?.attributes.length === 0)) ? (
                    <div className="text-center py-10">
                      <div className="symbol symbol-100px mx-auto mb-4">
                        <div className="symbol-label bg-light-warning">
                          <i className="fa-solid fa-exclamation-triangle text-warning fs-1"></i>
                        </div>
                      </div>
                     
                      <p className="text-muted fs-7">No specifications data found for this product.</p>
                    </div>
                  ) : (
                    (() => {
                      const attributeGroups = {
                        'Power': [
                          'AC adapter power',
                          'Charging port type',
                          'USB-C PD',
                          'USB-C Voltage',
                          'AC input voltage',
                          'Legacy AC adapter tip size',
                          'Legacy Power Tip'
                        ],
                        'Display': [
                          'Display diagonal',
                          'Display resolution',
                          'ASPECT RATIO',
                          'Touchscreen'
                        ],
                        'Video Ports': [
                          'DisplayPorts quantity',
                          'HDMI ports quantity',
                          'DVI port'
                        ],
                        'Cable Locks': [
                          'Cable lock slot',
                          'Cable lock slot type (1)',
                          'Cable lock slot type (2)',
                          'Universal'
                        ],
                        'Type-A ports': [
                          'Number of USB-A Ports',
                          'USB 3.2 GEN 2 (3.1 GEN 2) TYPE-A PORTS QUANTITY',
                          'USB 3.2 Gen 1 (3.1 Gen 1) Type-A ports quantity ',
                          'USB 2.0 Type-A Ports Quantity',
                          'USB 2.0 ports quantity'
                        ],
                        'Type-C Ports': [
                          'Number of USB-C Ports',
                          'USB 2.0 Type-C Ports',
                          'USB 3.2 GEN 1 (3.1 GEN 1) TYPE-C PORTS QUANTITY',
                          'USB 3.2 Gen 2 (3.1 Gen 2) Type-C ports quantity',
                          'DisplayPort Alt Mode Type-C Ports',
                          'Thunderbolt 3 Type-C Ports',
                          'Thunderbolt 4 Type-C Ports',
                          'USB4 Type-C ports',
                          'Thunderbolt 5 Type C Ports'
                        ],
                        'Audio Ports': [
                          'Combo headphone/mic port'
                        ],
                        'Communication': [
                          'Ethernet LAN (RJ-45) ports',
                          'Wi-Fi',
                          'Wi-Fi standards',
                          'Bluetooth'
                        ],
                        'Dimensions': [
                          'Width',
                          'Depth',
                          'Height',
                          'Weight'
                        ]
                      };

                      const allDefinedAttributes = Object.values(attributeGroups).flat();
                      const ProductDataAttributes = ProductData[0]?.attributes || [];

                      let groupedAttributes = Object.entries(attributeGroups).map(([groupName, attributeNames]) => ({
                        groupName,
                        attributes: ProductDataAttributes.filter((attribute: any) =>
                          attributeNames.includes(attribute.attributeName)
                        )
                      }));

                      const otherAttributes = ProductDataAttributes.filter(
                        (attribute: any) => !allDefinedAttributes.includes(attribute.attributeName)
                      );

                      if (otherAttributes.length > 0) {
                        groupedAttributes.push({
                          groupName: 'Others',
                          attributes: otherAttributes
                        });
                      }

                      groupedAttributes = groupedAttributes.filter(group => group.attributes.length > 0);

                      return groupedAttributes.map(({ groupName, attributes }) => (
                        <div key={`product-${groupName}`} className="mb-8">
                          <div className="card card-flush border-0 bg-light">
                            <div className="card-header min-h-50px">
                              <h5 className="card-title fw-bold text-dark-800 m-0">
                                {/* <i className="fa-solid fa-folder-open me-2 text-success"></i> */}
                                {groupName}
                              </h5>
                            </div>
                            <div className="card-body pt-4">
                              {attributes.map((attribute: any) => (
                                <div key={`product-attr-${attribute.attributeName}`} className="row mb-4 align-items-center">
                                  <div className="col-5">
                                    <label className="fw-semibold fs-7 text-dark-700 mb-0">
                                      {attribute.attributeName}
                                    </label>
                                  </div>
                                  <div className="col-7">
                                    <div className="input-group input-group-sm">
                                      <input
                                        value={attribute.value || "N/A"}
                                        disabled={true}
                                        className="form-control form-control-sm bg-white border-dark-300 text-dark"
                                        type="text"
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ));
                    })()
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end mt-7 gap-5">
        <button
          className="btn btn-primary btn-lg"
          onClick={handleApprove}
          disabled={approveLoading}
        >
          {approveLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Approving...
            </>
          ) : (
            <>
             
              Approve Product
            </>
          )}
        </button>

        <button
          className="btn btn-danger btn-lg"
          onClick={handleDelete}
          disabled={deleteLoading}
        >
          {deleteLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Refusing...
            </>
          ) : (
            <>

              Refuse
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default IcecatForm;